export const BANNER_API_URL = "https://admin.top11india.net/api/api.php?key=GetAllBanners&website=top11india.xyz";
export const NEWS_API_URL = "https://admin.top11india.net/api/api.php?key=GetAllNews&website=top11india.xyz";
